import {useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";
import {Form, Formik, isObject} from "formik";
import * as Yup from "yup";
import * as PropertyBucket from "../../Properties/Properties";
import * as httpService from "../HttpService/HttpService";
import PopUp from '.././PopUp/PopUp';
import Input from '.././Input/Input';
import DatePickerCustom from "../DatePickerCustom/DatePickerCustom";
import {customDateConversion} from "../DatePickerCustom/DateHelper";
import {getPostControlDocuments} from "../documents/helpers";

const FormSchema = Yup.object().shape({
  objectionsExistBool: Yup.boolean(),
  docsSendDescription: Yup.string().max(
    1000,
    "Treść pytania nie może być dłuższa niż 1000 znaków"
  ),
  receivedByControlledEntityDate: Yup.date()
  .when('objectionsExistBool', {
    is: true,
    then: () => Yup.date()
      .nullable()
      .required('Wybierz datę'),
    otherwise: () => Yup.date()
      .nullable()
  })

});


export const UploadDocumentsPopup = ({
  control,
  isObjectionExists,
  handleReload,
  handleClose,
  handleLoading,
  isPossibleSendData,
  isPossibleChangeDate,
  showPopup,
  isFinalInfo,
  isValidated
}) => {
  const objectionsExistBool = isObjectionExists;
  const receivedByControlledRef = useRef();
  const sendByControlledRef = useRef();
  const controlEndDatedRef = useRef();
  const [receivedByControlledEntityDate, setReceivedByControlledEntityDate] =
    useState("");
  const [finalInfoSendDate, setFinalInfoSendDate] = useState("");
  const [controlEndDate, setControlEndDate] = useState("");
  const [docsSendDescription, setDocsSendDescription] = useState("");
  const [controlDocuments, setControlDocuments] = useState("")

  useEffect(() => {

    (async () => {
      let documents = await getPostControlDocuments(control.id);

      setControlDocuments(documents);
    })();


  }, [])

  useEffect(() => {
    if(controlDocuments.length > 0) {
      const firstPostControlDocument = controlDocuments[0];

      const controlDocument = isPossibleChangeDate ? firstPostControlDocument.postControlInfo : firstPostControlDocument.postControlNote;

      if(controlDocument.receivedByControlledEntityDate) {
        setReceivedByControlledEntityDate(new Date(controlDocument.receivedByControlledEntityDate));
      }

      if (controlDocument.finalInfoSendDate) {
        setFinalInfoSendDate(new Date(controlDocument.finalInfoSendDate));
      }

      if (controlDocument.docsSendDescription) {
        setDocsSendDescription(controlDocument.docsSendDescription);
      }

      if(firstPostControlDocument && firstPostControlDocument.controlEndDate) {
        setControlEndDate(new Date(firstPostControlDocument.controlEndDate));
      }

    }
  }, [controlDocuments])

  return (
    <PopUp
      customContent
      handleClosePopup={handleClose}
      title="Przekazanie dokumentów"
    >
      <div id='editWindowTab'>
        <h5>Dotyczy kontroli: {control.number}</h5>
        <Formik
          validationSchema={FormSchema}
          enableReinitialize={true}
          initialValues={{
            receivedByControlledEntityDate,
            finalInfoSendDate,
            docsSendDescription,
            objectionsExistBool,
            controlEndDate
          }}
          onSubmit={({
            receivedByControlledEntityDate,
            finalInfoSendDate,
            docsSendDescription,
            controlEndDate
          }) => {
            let id;
            let url;

            if (isPossibleChangeDate){ // -> document type - INFO
              const postControlDocumentsArray = controlDocuments;
              const docINF = postControlDocumentsArray?.find(el => el.postControlInfo && !el.postControlInfo.isFinalInfo);
              const docOST = postControlDocumentsArray?.find(el => el.postControlInfo?.isFinalInfo);

              const idInf = docINF?.postControlInfo.id;
              url = PropertyBucket.getSendDocumentsDetilsControlInfo(idInf);

              const idOst = docOST?.postControlInfo.id;
              const urlOst = PropertyBucket.getSendDocumentsDetilsControlInfo(idOst);

              // double POST needed due to the data structure cotrol and strukture endpoint
              idOst && httpService
                .getServicePromise(urlOst, "POST", {
                  receivedByControlledEntityDate : receivedByControlledEntityDate ? customDateConversion(receivedByControlledEntityDate) : null,
                  finalInfoSendDate : finalInfoSendDate ? customDateConversion(finalInfoSendDate) : null,
                  docsSendDescription,
                  controlEndDate
                });
            }
            else { // -> document type - NOTE
              id = controlDocuments[0].postControlNote.id;
              url = PropertyBucket.getSendDocumentsControlNote(id);
            }

            httpService
              .getServicePromise(url, "POST", {
                receivedByControlledEntityDate : receivedByControlledEntityDate ? customDateConversion(receivedByControlledEntityDate) : null,
                finalInfoSendDate : finalInfoSendDate ? customDateConversion(finalInfoSendDate) : null,
                docsSendDescription,
                controlEndDate
              })
              .then(() => {
                showPopup(
                  "Komunikat",
                  "Dane zostały zapisane",
                  "notify",
                  () => handleClose()
                );
                handleReload();
              })
              .catch((err) => {
                showPopup("Błąd", "Dane nie zostały zapisane", "error");
              });
          }}
        >
          {({ values, errors }) => (
            <Form>
              {isPossibleChangeDate && (
                <div className='row flex-end-v'>
                  <div className='col-md-6'>
                    <DatePickerCustom
                      className='data-picker'
                      selected={values.receivedByControlledEntityDate}
                      datePickerId='receivedByControlledEntityDate'
                      name='receivedByControlledEntityDate'
                      label='Data otrzymania informacji pokontrolnej przez podmiot kontrolowany'
                      labelClassName='mt-3 font-weight-bold'
                      dateName='datę otrzymania informacji pokontrolnej przez podmiot kontrolowany'
                      onChange={(date) =>
                        setReceivedByControlledEntityDate(date)
                      }
                      disabled={isFinalInfo && isValidated ? !isFinalInfo : !isValidated}
                      parentRef={receivedByControlledRef}
                      inputId='receivedByControlledEntityDate'
                      errorId='receivedByControlledEntityDateError'
                      error={errors.receivedByControlledEntityDate && errors.receivedByControlledEntityDate}
                    />
                  </div>
                  <div className='col-md-6'>
                    <DatePickerCustom
                      datePickerId='finalInfoSendDate'
                      name='finalInfoSendDate'
                      className='data-picker'
                      selected={values.finalInfoSendDate}
                      onChange={(date) => {
                        setFinalInfoSendDate(date);
                      }}
                      label='Data wysłania informacji ostatecznej'
                      dateName='wysłania informacji ostatecznej'
                      labelClassName='mt-3 font-weight-bold'
                      disabled={!(isFinalInfo && isValidated)}
                      parentRef={sendByControlledRef}
                      minDate={values.receivedByControlledEntityDate}
                    />
                  </div>
                </div>
              )}
              <div className='row'>
                  <div className='col-md-6'>
                    <DatePickerCustom
                      datePickerId='controlEndDate'
                      name='controlEndDate'
                      className='data-picker'
                      selected={values.controlEndDate}
                      onChange={(date) => {
                        setControlEndDate(date);
                      }}
                      disabled={!isPossibleSendData}
                      label='Data zakończenia kontroli'
                      dateName='zakończenia kontroli'
                      labelClassName='mt-3 font-weight-bold'
                      parentRef={controlEndDatedRef}
                    />
                  </div>
              </div>
              <div className='row'>
                <div className='col-12'>
                  <Input
                    formik
                    chartsCount={values.docsSendDescription.length || 0}
                    maxLength={1000}
                    component='textarea'
                    rows='5'
                    name='docsSendDescription'
                    className='editFields'
                    value={values.docsSendDescription}
                    disabled={!isPossibleSendData}
                    label='Uwagi'
                    labelClassName='mt-3 font-weight-bold'
                    inputId='docsDescrId'
                    errorId='docsDescrError'
                    error={errors.docsSendDescription && errors.docsSendDescription}
                    onChange={ev => setDocsSendDescription(ev.target.value)}
                  />
                </div>
              </div>

              <div className='btn_group mb-2'>
                {isPossibleSendData ? (
                  <>
                    <button
                      className='btn save-btn'
                      id='save_button'
                      type='submit'
                    >
                      ZAPISZ
                    </button>
                    <button
                      type='button'
                      className='btn cancel-btn'
                      onClick={handleClose}
                    >
                      ANULUJ
                    </button>
                  </>
                ) : (
                  <button
                    className='btn save-btn'
                    id='save_button'
                    type='button'
                    onClick={handleClose}
                  >
                    OK
                  </button>
                )}
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </PopUp>
  );
};

UploadDocumentsPopup.defaultProps = {
  isPossibleSendData: false,
  isPossibleChangeDate: false,
};

UploadDocumentsPopup.propTypes = {
  showPopup: PropTypes.func.isRequired,
  control: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleLoading: PropTypes.func.isRequired,
  isPossibleSendData: PropTypes.bool,
  isPossibleChangeDate: PropTypes.bool,
};
